"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

require("./styles/_select-user-item.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function SelectUserItem(_ref) {
  var user = _ref.user,
      selected = _ref.selected,
      onButtonClick = _ref.onButtonClick;
  var userId = user.userId,
      email = user.email,
      imageUrl = user.imageUrl,
      firstName = user.firstName,
      lastName = user.lastName;
  var displayName = "".concat(firstName, " ").concat(lastName);
  return (/*#__PURE__*/_react.default.createElement("div", {
      key: userId,
      className: (0, _classnames.default)('select-user-item', {
        'select-user-item--selected': selected
      })
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
      imageUrl: imageUrl,
      placeholderText: displayName,
      width: "75px",
      height: "75px"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "select-user-item__info"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "select-user-item__info__primary"
    }, displayName), /*#__PURE__*/_react.default.createElement("p", {
      className: "select-user-item__info__secondary"
    }, email)), onButtonClick ? /*#__PURE__*/_react.default.createElement("div", {
      className: "select-user-item__right-container"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      className: "select-user-item__right-container__button",
      onClick: onButtonClick,
      type: selected ? 'PRIMARY' : 'INVERTED',
      small: true
    }, selected ? 'DESELECT' : 'SELECT')) : null)
  );
}

var _default = (0, _react.memo)(SelectUserItem);

exports.default = _default;